import React, {useContext, useEffect, useRef, useState} from 'react';
import {Context} from "../../index";
import {observer} from "mobx-react-lite";
import "./LoadingAdmin.css";
import {adminLogin} from "../../http/userAPI";
import {runInAction} from 'mobx';

const LoadingAdmin = observer(() => {

    const {settings, user, main, basket} = useContext(Context);
    const session = main.basketSession;
    const [formState, setFormState] = useState('spinnerActive');
    const mountedRef = useRef(false);
    const flowRef = useRef(0);
    const attemptRef = useRef(null);

    useEffect(() => {

        mountedRef.current = true;
        const timer = setTimeout(() => {
            if (mountedRef.current) setFormState('formActive');
        }, 1000);
        return () => {
            mountedRef.current = false;
            flowRef.current += 1;
            clearTimeout(timer);
            session.cancelAttempt(attemptRef.current);
            attemptRef.current = null;
        };
    }, [session]);

    const [loginState, setLoginState] = useState('');
    const [passwordState, setPasswordState] = useState('');
    const [errorLog,setErrorLog] = useState('');
    const loginSetAndValid = (value) => {
        if(value.length*1 > 25) {
            return false;
        }
        setLoginState(value);
    }
    const passwordSetAndValid = (value) => {
        if(value.length*1 > 45) {
            return false;
        }
        setPasswordState(value);
    }

    const adminLoginPassword = async () => {
        if (!mountedRef.current) return false;
        const flow = ++flowRef.current;
        session.cancelAttempt(attemptRef.current);
        setErrorLog('');
        let attempt;
        try {
            attempt = session.startLoginAttempt();
        } catch {
            setErrorLog('Не удалось войти. Попробуйте ещё раз.');
            return false;
        }
        attemptRef.current = attempt;
        const currentAttempt = () => mountedRef.current && flowRef.current === flow &&
            attemptRef.current === attempt && session.isCurrent(attempt);
        // Only the actual token branch invokes this witness. Current checks stay
        // pure: a no-token raw principal-shaped DTO must never admit an account.
        let tokenBranchSeen = false;
        const canCommitCurrentToken = () => {
            if (!currentAttempt()) return false;
            tokenBranchSeen = true;
            return true;
        };
        let data;
        try {
            if (!currentAttempt()) return false;
            data = await adminLogin(loginState, passwordState,
                {canCommitToken: canCommitCurrentToken, commitContext: attempt});
        } catch {
            if (currentAttempt()) {
                runInAction(() => session.failAuth(attempt));
                setErrorLog('Не удалось войти. Попробуйте ещё раз.');
            }
            return false;
        }
        if (!currentAttempt()) return false;
        if (data?.error) {
            runInAction(() => session.failAuth(attempt));
            setErrorLog(['Заполните поля', 'Доступ запрещен'].includes(data.error) ?
                data.error : 'Не удалось войти. Попробуйте ещё раз.');
            return false;
        }
        if (!tokenBranchSeen || !session.acceptAuth(attempt, data)) {
            runInAction(() => session.failAuth(attempt));
            setErrorLog('Не удалось войти. Попробуйте ещё раз.');
            return false;
        }
        attemptRef.current = null;
        // Accepted tickets retire. Later callbacks belong to the accepted epoch
        // and this component lifetime, not an obsolete attempt or just user id.
        const epoch = basket.sessionEpoch;
        const currentAccepted = () => mountedRef.current && flowRef.current === flow &&
            basket.sessionEpoch === epoch && basket._session?.principalId === data.id &&
            user.isAuth === true && user.user?.id === data.id;
        try {
            const result = await session.refresh();
            if (currentAccepted() && result.status !== 'accepted') {
                setErrorLog('Не удалось обновить корзину. Попробуйте ещё раз.');
            }
        } catch {
            if (currentAccepted()) setErrorLog('Не удалось обновить корзину. Попробуйте ещё раз.');
        }
        return true;

    }

    return (
        <div style={{marginTop:settings.headerHeight}}  className={"main adminCheck"}>
               <div className={"spin_wrapper " + formState}>
                   <div className={"spinner "}></div>
               </div>

                <div className={"admin_auth_form_container " + formState}>
                        <span className="auth_page_title">Авторизация</span>
                        <div className="auth_form_for_admin">
                            <div className="inputwrapper_auth_form">
                                <label htmlFor="admin-login" className={"name_field_auth"}>Login</label>
                                <input
                                    id="admin-login"
                                    className={"auth_input_atm login"}
                                    type="text"
                                    value={loginState}
                                    onChange={e => loginSetAndValid(e.target.value) }
                                />
                            </div>
                            <div className="inputwrapper_auth_form">
                                <label htmlFor="admin-password" className={"name_field_auth"}>Password</label>
                                <input
                                    id="admin-password"
                                    className={"auth_input_atm password"}
                                    type="password"
                                    value={passwordState}
                                    onChange={e => passwordSetAndValid(e.target.value) }
                                />
                            </div>
                            <div className={"error_field_auth_admin_page"}>{errorLog}</div>
                            <button type="button"
                                onClick={e => adminLoginPassword() }
                                className={"auth_button_admin"}>Войти</button>
                        </div>
                </div>
        </div>


    );
});

export default LoadingAdmin;
